import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from './pazymaBusena'
import math from '@/mixins/math'

export default {
  mixins: [userRole, busena, math],
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'pazymaID',
      'pazymaReadonly',
      'pazymaBusena',
      'pazymaTipas',
      'savitarnaKrepselisUrl',
    ]),
  },
  created() {},
  methods: {
    validate(button) {
      let ans = false
      switch (button) {
        case 'Tęsti':
          ans = true
          break
        case 'Atšaukti':
          ans = true
          break
        case 'Tikrinti savitarna':
          ans = this.isRengiamas
          break
        case 'Užsakyti pažymą':
          ans =
            this.isRengiamas &&
            this.pazyma?.veiksmai.includes('pazyma-uzsakymas')
          break
        case 'Mokėti':
          ans =
            // this.isLaukiaApmokejimo &&
            this.pazyma?.veiksmai &&
            this.pazyma?.veiksmai.includes('pazyma-mokejimas')
          break
      }

      return ans
    },
    veiksmasStatus(veiksmas, toliau = null) {
      this.loading = true

      this.$axios
        .get(`ntrpaslaugos/pazyma/${this.pazymaID}/veiksmas/${veiksmas}/status`)
        .then(res => {
          this.$store.dispatch('checkErrors', res.data.klaidos)

          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
            return
          }

          if (this.showPazymaTurtas) {
            this.reloadTurtas()
          }

          if (res.data.status.can_change && toliau) {
            this[toliau]()
            return
          }
          this.loading = false
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          // this.loading = false
        })
    },
    pazymaUzsakyti() {
      this.loading = true

      this.$axios
        .post(`ntrpaslaugos/pazyma/${this.pazymaID}/veiksmas/pazyma-uzsakymas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('checkErrors', null)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
            return
          }
          this.updatePazyma()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          // this.loading = false
        })
    },
    pazymaMoketi(pazymaID = this.pazymaID) {
      this.loading = true

      this.$axios
        .post(`ntrpaslaugos/pazyma/${pazymaID}/veiksmas/pazyma-mokejimas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('checkErrors', null)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
            return
          }
          this.updatePazyma()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePazyma() {
      //
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute(
        'download',
        this.safeFileName(`${this.dokumentasTipas}.docx`)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    gotoKrepselis(krepselis_id = null) {
      this.loading = true
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
    cancelPazyma() {
      this.$router.push({
        name: this.pazymaRouteList,
        params: {
          pazymaKodas: this.pazymaKodas,
        },
      })
    },
  },
}
